/* globals jQuery, google */
import { debounce } from 'throttle-debounce'

(($) => {

    //HIDE/SHOW FILTERS - mobile
    $('.js-filter-button').on('click', function(e){
        e.preventDefault();
        $(this).next('.accordion--filters').slideToggle();
    });
    $(window).on('resize', debounce(150, function() {
        $('.accordion--filters').removeAttr('style');
    }));

    //FILTER TAG SVG
    const filterTagSvg = '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="4.69922" y="5.30273" width="1.397" height="13.97" transform="rotate(-45 4.69922 5.30273)" fill="black"/><rect x="5.17871" y="15.1807" width="1.397" height="13.97" transform="rotate(-135 5.17871 15.1807)" fill="black"/></svg>'; 
    //FILTER FORM VARIABLES
    let filterForm = document.getElementById('filterForm');
    let filterFields = filterForm.querySelectorAll('input');

    //HANDLE FORM SUBMIT
    filterForm.addEventListener('submit',(event) => {
        event.preventDefault();

        const formData = new FormData(event.target);
        const filterData = new URLSearchParams(formData);

        //DISPLAY LOADING
        document.querySelector('.filter-grid').classList.add('filter-grid--loading');

        //SETUP AJAX REQUEST TO FILTER DATA ON THE PAGE
        fetch(site_data.WP_AJAX,{
            method: 'POST',
            body: filterData
        })
        .then(response => response.json())
        .then(response => {
            if (!response.success) {
                throw new Error(response.errors.join(', '));
            }

            //replace html cards for posts into `js-filtered-grid-list` element
            $('.js-filtered-grid-list').html(response.html);

            //REMOVE LOADING INDICATOR
            document.querySelector('.filter-grid').classList.remove('filter-grid--loading');
        })
        .catch(error => {
            console.log('Unable to fetch data', error);
            //REMOVE LOADING INDICATOR
            document.querySelector('.filter-grid').classList.remove('filter-grid--loading');
        });

    });

    //SUBMIT FILTER FORM ON FIELD CHANGE
    filterFields.forEach((currentElement) => {
        currentElement.addEventListener('change',(event) => {
            
            let ElementId = currentElement.getAttribute('id');
            let ElementValue = currentElement.getAttribute('value');
            let ElementLabel = $("label[for='" + ElementId + "']").text();
            let ElementLabelName = currentElement.getAttribute('name');

            //only append that filter tag to the list if its getting checked
            if( currentElement.getAttribute('type') === 'checkbox' && currentElement.checked ){
                // svg and the inner text of the changed inputs label
                let filterTagText = filterTagSvg + ElementLabel;
                // append the new tag to the filter list
                let filterTag = `<a class="filter-tag" data-labelid="${ElementId}" data-filter="${ElementLabelName}" data-value="${ElementValue}" href="#">${filterTagText}</a>`;
                $('.filter-tags').append(filterTag);
            }
            else{
                //remove the filter tag that was unchecked
                $('.filter-tag[data-labelid="'+ElementId+'"]').remove();
            }

            //re-add the event listener to the filter tags
            //addEventListenerToFilterTags();
            
            // submit the request
            filterForm.requestSubmit();
            
        });
    });
    //addEventListenerToFilterTags();

    //since we have jquery already we are going to use it to make listening for clicks on dynamic elements easier
    //listen for click on the tag
    $(document).on('click', 'a.filter-tag', (event) => {
        event.preventDefault();

        let tagElement = event.target;
        let filter = tagElement.dataset.filter; //field name
        let filterValue = tagElement.dataset.value; //filter value

        console.log('remove filter');

        //loop through filter fields and uncheck any that match the tag clicked
        filterFields.forEach((fieldElement) => {
            console.log(filterValue);
            //console.log(fieldElement.getAttribute('name') + " = " + fieldElement.value);
            //if the name and value on the filter field matches are tag clicked 
            // uncheck the filter and submit the filter form
            if( fieldElement.getAttribute('name') === filter && fieldElement.value === filterValue ){
                //uncheck that filter
                fieldElement.checked = false;
                //remove the tag
                tagElement.remove();
                //resubmit the filter form
                filterForm.requestSubmit();
            }
        });

    }); //end click listener

})(jQuery);